/**
 * 格式化日期
 * @param {Date|string|number|Array} date 日期对象、日期字符串、时间戳或数组[年,月,日,时,分,秒]
 * @param {string} format 格式化模式，默认为 'YYYY-MM-DD HH:mm:ss'
 * @returns {string} 格式化后的日期字符串
 */
export const formatDate = (date, format = 'YYYY-MM-DD HH:mm:ss') => {
  if (!date) return '';
  
  // 处理数组格式的日期 [year, month, day, hour, minute, second]
  if (Array.isArray(date)) {
    const year = date[0];
    const month = padZero(date[1] || 0);
    const day = padZero(date[2] || 0);
    const hours = padZero(date[3] || 0);
    const minutes = padZero(date[4] || 0);
    const seconds = padZero(date[5] || 0);
    
    return format
      .replace('YYYY', year)
      .replace('MM', month)
      .replace('DD', day)
      .replace('HH', hours)
      .replace('mm', minutes)
      .replace('ss', seconds);
  }
  
  // 转换为Date对象
  let dateObj = date;
  if (typeof date === 'string' || typeof date === 'number') {
    dateObj = new Date(date);
  }
  
  // 检查日期是否有效
  if (isNaN(dateObj.getTime())) {
    return '';
  }
  
  const year = dateObj.getFullYear();
  const month = padZero(dateObj.getMonth() + 1);
  const day = padZero(dateObj.getDate());
  const hours = padZero(dateObj.getHours());
  const minutes = padZero(dateObj.getMinutes());
  const seconds = padZero(dateObj.getSeconds());
  
  return format
    .replace('YYYY', year)
    .replace('MM', month)
    .replace('DD', day)
    .replace('HH', hours)
    .replace('mm', minutes)
    .replace('ss', seconds);
};

/**
 * 补零
 * @param {number} num 数字
 * @returns {string} 补零后的字符串
 */
function padZero(num) {
  return num < 10 ? '0' + num : String(num);
}

/**
 * 格式化相对时间
 * @param {Date|string|number|Array} date 日期对象、日期字符串、时间戳或数组[年,月,日,时,分,秒]
 * @returns {string} 相对时间描述
 */
export const formatRelativeTime = (date) => {
  if (!date) return '';
  
  // 处理数组格式的日期 [year, month, day, hour, minute, second]
  if (Array.isArray(date)) {
    const year = date[0];
    const month = (date[1] || 1) - 1; // 月份是0-11
    const day = date[2] || 1;
    const hours = date[3] || 0;
    const minutes = date[4] || 0;
    const seconds = date[5] || 0;
    
    const dateObj = new Date(year, month, day, hours, minutes, seconds);
    // 检查日期是否有效
    if (isNaN(dateObj.getTime())) {
      return '';
    }
    
    const now = new Date();
    const diff = now.getTime() - dateObj.getTime();
    
    // 小于1分钟
    if (diff < 60 * 1000) {
      return '刚刚';
    }
    
    // 小于1小时
    if (diff < 60 * 60 * 1000) {
      return Math.floor(diff / (60 * 1000)) + '分钟前';
    }
    
    // 小于1天
    if (diff < 24 * 60 * 60 * 1000) {
      return Math.floor(diff / (60 * 60 * 1000)) + '小时前';
    }
    
    // 小于30天
    if (diff < 30 * 24 * 60 * 60 * 1000) {
      return Math.floor(diff / (24 * 60 * 60 * 1000)) + '天前';
    }
    
    // 小于12个月
    if (diff < 12 * 30 * 24 * 60 * 60 * 1000) {
      return Math.floor(diff / (30 * 24 * 60 * 60 * 1000)) + '个月前';
    }
    
    // 大于等于12个月
    return Math.floor(diff / (12 * 30 * 24 * 60 * 60 * 1000)) + '年前';
  }
  
  // 转换为Date对象
  let dateObj = date;
  if (typeof date === 'string' || typeof date === 'number') {
    dateObj = new Date(date);
  }
  
  // 检查日期是否有效
  if (isNaN(dateObj.getTime())) {
    return '';
  }
  
  const now = new Date();
  const diff = now.getTime() - dateObj.getTime();
  
  // 小于1分钟
  if (diff < 60 * 1000) {
    return '刚刚';
  }
  
  // 小于1小时
  if (diff < 60 * 60 * 1000) {
    return Math.floor(diff / (60 * 1000)) + '分钟前';
  }
  
  // 小于1天
  if (diff < 24 * 60 * 60 * 1000) {
    return Math.floor(diff / (60 * 60 * 1000)) + '小时前';
  }
  
  // 小于30天
  if (diff < 30 * 24 * 60 * 60 * 1000) {
    return Math.floor(diff / (24 * 60 * 60 * 1000)) + '天前';
  }
  
  // 小于12个月
  if (diff < 12 * 30 * 24 * 60 * 60 * 1000) {
    return Math.floor(diff / (30 * 24 * 60 * 60 * 1000)) + '个月前';
  }
  
  // 大于等于12个月
  return Math.floor(diff / (12 * 30 * 24 * 60 * 60 * 1000)) + '年前';
}; 


// WEBPACK FOOTER //
// ./src/utils/format.js